import React from "react";
import { Form, Input } from "semantic-ui-react";

const NumberInput = ({
  label,
  defaultValue,
  inline,
  unitLabel,
  meta: { error, touched },
  ...rest
}) => (
  <Form.Field inline={inline} defaultValue={defaultValue} error={error && touched}>
    <label>{label}</label>
    <Input type="number" label={unitLabel} error={!!error} {...rest} />
    {error && touched ? <span style={{ color: "red" }}>*{error}</span> : ""}
  </Form.Field>
);

export default NumberInput;
